import xss from 'xss';
import { setAnchorElementsTarget } from '../util';
import { ESCALATION, POLICY, GUIDE, PRODUCTS, SALE_PROMO, READ, UPDATED, ESCALATION_PARTNER } from 'constants/alerts';

export const getIconForAlert = (type) => {
  switch (type) {
    case POLICY:
      return '/images/alert-icon-policy-change.svg';
    case ESCALATION:
      return '/images/alert-icon-escalation.svg';
    case ESCALATION_PARTNER:
      return '/images/alert-icon-escalation.svg';
    case GUIDE:
      return '/images/alert-icon-process.svg';
    case PRODUCTS:
      return '/images/alert-icon-product.svg';
    case SALE_PROMO:
      return '/images/alert-icon-sales-promo.svg';
    default:
      return '';
  }
};

export const parseSanitizedAlertContent = (html) => {
  let __html = xss(html, {
    whiteList: {
      a: ['href', 'title', 'target'],
      p: [],
      strong: [],
      br: [],
      span: ['style'],
      ul: [],
      li: [],
    },
    stripIgnoreTag: true,
  });
  __html = setAnchorElementsTarget(__html);

  return {
    dangerouslySetInnerHTML: {
      __html,
    },
  };
};

export const getReadStatusLabel = (alert) => {
  const read = alert.readStatus === READ;
  const updated = alert.readStatus === UPDATED;
  if (read) {
    return 'READ';
  } else if (updated) {
    return 'UPDATED';
  }

  return 'UNREAD';
};
